(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWtoucan_atlas_", frames: [[0,0,208,208],[624,320,176,176],[478,0,266,162],[210,0,266,162],[746,0,218,158],[210,164,218,158],[430,164,192,168],[0,210,192,168],[538,334,82,76],[0,380,72,68],[366,334,170,134],[194,324,170,134],[802,320,216,130],[966,162,42,46],[802,452,212,90],[0,460,212,90],[214,460,144,130],[966,86,52,74],[966,0,58,84],[624,260,76,44],[624,164,94,94],[746,160,218,158],[360,470,171,94]]}
];


// symbols:



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.ToucanHead_0010001 = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.ToucanHead_0010002 = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.ToucanHead_0020001 = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.ToucanHead_0020002 = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.ToucanHead_0030001 = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.ToucanHead_0030002 = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.ToucanLeg = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.ToucanLowerLeg = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.ToucanTail0001 = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.ToucanTail0002 = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.ToucanTorso = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.ToucanUpperLeg = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.ToucanWing0001 = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.ToucanWing0002 = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.ToucanWingspanHead20002 = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.ToucanWingspanLeftLeg = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.ToucanWingspanRightLeg = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.ToucanWingspanTail = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.ToucanWingspanTorso = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.ToucanWingspanWing = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.Tween1fdfsvtoucanwing = function() {
	this.spriteSheet = ss["MWtoucan_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.Tween1fdfsvtoucanwing_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Tween1fdfsvtoucanwing();
	this.instance.parent = this;
	this.instance.setTransform(-40,-17,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-44,-26.3,92.8,58);


(lib.ToucanWingspanWing_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ToucanWingspanWing();
	this.instance.parent = this;
	this.instance.setTransform(-2.5,-4.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ToucanWingspanWing_1, new cjs.Rectangle(-2.5,-6.2,109,81), null);


(lib.ToucanWingspanTorso_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ToucanWingspanTorso();
	this.instance.parent = this;
	this.instance.setTransform(2.8,-2.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ToucanWingspanTorso_1, new cjs.Rectangle(2.8,-2.2,47,47), null);


(lib.ToucanWingspanTail_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ToucanWingspanTail();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ToucanWingspanTail_1, new cjs.Rectangle(-2,-2,38,22), null);


(lib.ToucanWingspanRightLeg_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ToucanWingspanRightLeg();
	this.instance.parent = this;
	this.instance.setTransform(-1.5,-7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ToucanWingspanRightLeg_1, new cjs.Rectangle(-2.5,-8,30,43.1), null);


(lib.ToucanWingspanLeftLeg_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ToucanWingspanLeftLeg();
	this.instance.parent = this;
	this.instance.setTransform(-4.3,-3.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ToucanWingspanLeftLeg_1, new cjs.Rectangle(-6.1,-5.6,27.9,39.4), null);


(lib.ToucanWingspanHead2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ToucanWingspanHead20002();
	this.instance.parent = this;
	this.instance.setTransform(-5,-3.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5,-6.6,73,67.9);


(lib.toucan_tailGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(3,1,1).p("ADAASQgCgHgvgYQglgUgTgHQgOgGhSgoQhHgigigMQgbgKggAlQggAlAVALQACAGA8AkQAgASAyAeQABAABEA0QBFAzAGgBQAFgCAEgIQADgIAIgCQAOgEADgMQACgIgDgFIgBgBQAZgEABgOQgDgQAAgEQAFAAAHgCQARgFACgLg");
	this.shape.setTransform(22.2,15.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.toucan_tailGlow, new cjs.Rectangle(1.4,0.3,41.7,30), null);


(lib.toucan_beakGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(3,1,1).p("AioASQAUgUAWgSQAXgSAagOQARgIASgHQAQgFAQgFQACAAACgBQAXgGAkgHQAJgEATABQAcAAAIACIAjADQAWADAQACQAPACgCAGQgBAHgGAGQgGAGAAACQAAABADAOQAEAPAAAHQAAAfgIAPQgCACgBADQgVAfg9AAQgcAAgzgGQgZgDgZgDIgrAAQgFABgHAAQgLAAgIAAQgaAFgbAPQgCAAgBABIgBABQgFADgHAEQgKAGgHADQAAAAgBABQgDACgDACQgDAAgBgBQgBAAAAAAQgDgBgBgDQgBgEAAgFQAAgMAJgRIADgFQACgEADgEIADgEQAEgJAGgIAibBKQADgCACgBQgCABgBABQAAAAgBAAgAi/BeQgCAAgBABIAAAAQABgBACAAIAFgC");
	this.shape.setTransform(20.3,9.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.toucan_beakGlow, new cjs.Rectangle(-1.5,-1.5,43.7,22.1), null);


(lib.toucan_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(3,1,1).p("ADMBQQhIhOgvgfQhrhJiUgdQgGBAgfAiQBsBoBbAfQBaAfBGgBQBHgBgTgzg");
	this.shape.setTransform(36.2,6.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.toucan_backGlow, new cjs.Rectangle(13.9,-8.3,44.6,29.5), null);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.bluetailglow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(3,1,1).p("ADAASQgCgHgvgYQglgUgTgHQgOgGhSgoQhHgigigMQgbgKggAlQggAlAVALQACAGA8AkQAgASAyAeQABAABEA0QBFAzAGgBQAFgCAEgIQADgIAIgCQAOgEADgMQACgIgDgFIgBgBQAZgEABgOQgDgQAAgEQAFAAAHgCQARgFACgLg");
	this.shape.setTransform(22.2,15.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bluetailglow, new cjs.Rectangle(1.4,0.3,41.7,30), null);


(lib.bluebeakglow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(3,1,1).p("AioASQAUgUAWgSQAXgSAagOQARgIASgHQAQgFAQgFQACAAACgBQAXgGAkgHQAJgEATABQAcAAAIACIAjADQAWADAQACQAPACgCAGQgBAHgGAGQgGAGAAACQAAABADAOQAEAPAAAHQAAAfgIAPQgCACgBADQgVAfg9AAQgcAAgzgGQgZgDgZgDIgrAAQgFABgHAAQgLAAgIAAQgaAFgbAPQgCAAgBABIgBABQgFADgHAEQgKAGgHADQAAAAgBABQgDACgDACQgDAAgBgBQgBAAAAAAQgDgBgBgDQgBgEAAgFQAAgMAJgRIADgFQACgEADgEIADgEQAEgJAGgIAi/BeQgCAAgBABIAAAAQABgBACAAIAFgC");
	this.shape.setTransform(20.3,9.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#FFFF00").ss(3,1,1).p("AgBABQABgBACAAQgBAAgBAAQAAAAAAABg");
	this.shape_1.setTransform(5,16.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.bluebeakglow, new cjs.Rectangle(-1.5,-1.5,43.7,22.1), null);


(lib.bluebackglow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(3,1,1).p("ADMBQQhIhOgvgfQhrhJiUgdQgGBAgfAiQBsBoBbAfQBaAfBGgBQBHgBgTgzg");
	this.shape.setTransform(36.2,6.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bluebackglow, new cjs.Rectangle(13.9,-8.3,44.6,29.5), null);


(lib.beackglow3blue = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(3,1,1).p("AioASQAUgUAWgSQAXgSAagOQARgIASgHQAQgFAQgFQACAAACgBQAXgGAkgHQAJgEATABQAcAAAIACIAjADQAWADAQACQAPACgCAGQgBAHgGAGQgGAGAAACQAAABADAOQAEAPAAAHQAAAfgIAPQgCACgBADQgVAfg9AAQgcAAgzgGQgZgDgZgDIgrAAQgFABgHAAQgLAAgIAAQgaAFgbAPQgCAAgBABIgBABQgFADgHAEQgKAGgHADQAAAAgBABQgDACgDACQgDAAgBgBQgBAAAAAAQgDgBgBgDQgBgEAAgFQAAgMAJgRIADgFQACgEADgEIADgEQAEgJAGgIAi/BeQgCAAgBABIAAAAQABgBACAAIAFgC");
	this.shape.setTransform(20.3,9.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#FFFF00").ss(3,1,1).p("AgBABQABgBACAAQgBAAgBAAQAAAAAAABg");
	this.shape_1.setTransform(5,16.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.beackglow3blue, new cjs.Rectangle(-1.5,-1.5,43.7,22.1), null);


(lib.beackglow2blue = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(3,1,1).p("AioASQAUgUAWgSQAXgSAagOQARgIASgHQAQgFAQgFQACAAACgBQAXgGAkgHQAJgEATABQAcAAAIACIAjADQAWADAQACQAPACgCAGQgBAHgGAGQgGAGAAACQAAABADAOQAEAPAAAHQAAAfgIAPQgCACgBADQgVAfg9AAQgcAAgzgGQgZgDgZgDIgrAAQgFABgHAAQgLAAgIAAQgaAFgbAPQgCAAgBABIgBABQgFADgHAEQgKAGgHADQAAAAgBABQgDACgDACQgDAAgBgBQgBAAAAAAQgDgBgBgDQgBgEAAgFQAAgMAJgRIADgFQACgEADgEIADgEQAEgJAGgIAi/BeQgCAAgBABIAAAAQABgBACAAIAFgC");
	this.shape.setTransform(20.3,9.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#FFFF00").ss(3,1,1).p("AgBABQABgBACAAQgBAAgBAAQAAAAAAABg");
	this.shape_1.setTransform(5,16.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.beackglow2blue, new cjs.Rectangle(-1.5,-1.5,43.7,22.1), null);


(lib.ToucanUpperLeg_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ToucanUpperLeg();
	this.instance.parent = this;
	this.instance.setTransform(-8.5,-9.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ToucanUpperLeg_1, new cjs.Rectangle(-8.5,-9.5,21,23), null);


(lib.ToucanTorso_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ToucanTorso();
	this.instance.parent = this;
	this.instance.setTransform(-51.9,-31.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ToucanTorso_1, new cjs.Rectangle(-51.9,-31.7,108,65), null);


(lib.ToucanLowerLeg_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.ToucanLowerLeg();
	this.instance.parent = this;
	this.instance.setTransform(-16.5,-16.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ToucanLowerLeg_1, new cjs.Rectangle(-20.6,-20.3,40.1,38.1), null);


(lib.ToucanLeg_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.ToucanLeg();
	this.instance.parent = this;
	this.instance.setTransform(-19.7,-18.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ToucanLeg_1, new cjs.Rectangle(-21.7,-20.4,43,40), null);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.ToucanWing_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wash:0,wash_stop:39});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-27,-2.1,0.721,0.723,0,-11.4,-11.6,35.7,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(3.9,-13.3,0.721,0.723,0,163.8,163.6,35.6,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},38).wait(50));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ToucanWing = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,clean:2,clean_loop:3,glow:4,glow_loop:5,"wash":6,"wash_stop":51,glowclean:66,glowclean_stop:67,"final":68,final_loop:69});

	// Layer 4
	this.instance = new lib.ToucanWing0001();
	this.instance.parent = this;
	this.instance.setTransform(-51.5,-20.7,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-5.5,-0.3,0.75,0.75,0,0,0,50.6,5.2);

	this.instance_2 = new lib.ToucanWing0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-51.5,-20.7,0.5,0.5);

	this.instance_3 = new lib.toucan_backGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-6.6,-8.3,2,2,0,0,180,36.2,6.4);

	this.glow = new lib.bluebackglow();
	this.glow.parent = this;
	this.glow.setTransform(-6.6,-8.3,2,2,0,0,180,36.2,6.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},8).to({state:[{t:this.instance_2},{t:this.instance_1}]},37).to({state:[]},1).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},14).to({state:[{t:this.instance_2}]},2).wait(211));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-51.5,-20.7,106,45);


(lib.ToucanTail_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":44});

	// Layer 4
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-20,6.9,0.66,0.662,0,-37.8,-38,35.9,11);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(0.4,-14.8,0.66,0.662,0,137.4,137.2,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},43).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ToucanTail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":50,"glowclean":62,"glowclean_stop":63,"final":64,"final_loop":65});

	// Layer 5
	this.instance = new lib.ToucanTail0001();
	this.instance.parent = this;
	this.instance.setTransform(-32.2,-31.7,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-0.3,-4.9,0.5,0.5,0,0,0,47.6,10.1);

	this.instance_2 = new lib.left_over_bubbles_few();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-8.9,7.1,1,1,0,0,0,47.8,9.3);

	this.instance_3 = new lib.ToucanTail0002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-32.2,-31.7,0.5,0.5);

	this.instance_4 = new lib.toucan_tailGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-2.8,6,1.5,1.5,0,-15,165,22.2,15.2);

	this.glow = new lib.bluetailglow();
	this.glow.parent = this;
	this.glow.setTransform(-2.8,6,1.5,1.5,0,-15,165,22.2,15.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_4}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},8).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},36).to({state:[]},1).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},11).to({state:[{t:this.instance_3}]},2).wait(212));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-32.2,-31.7,85,67);


(lib.ToucanHead_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":59});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(58.6,-23.5,0.655,0.658,0,-172.4,-172.7,35.6,11);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(34.2,-25.1,0.721,0.723,0,12.3,12.1,35.8,11);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(76.2,-12.3,0.655,0.658,0,-172.4,-172.7,35.5,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},58).wait(49));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ToucanHead_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":71,"glowclean":85,glowclean_loop:86,"final":87,"final_loop":88});

	// Layer 3
	this.instance = new lib.ToucanHead_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-24.5,-41,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(47.2,-24,0.5,0.5,0,0,180,50.6,5.2);

	this.instance_2 = new lib.ToucanHead_0010002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-24.5,-41,0.5,0.5);

	this.instance_3 = new lib.toucan_beakGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(53.6,-17.8,1.5,1.5,0,0,180,20.2,9.6);

	this.glow = new lib.bluebeakglow();
	this.glow.parent = this;
	this.glow.setTransform(50.9,-18.6,1.6,1.5,0,0,180,20.2,9.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},8).to({state:[{t:this.instance_2},{t:this.instance_1}]},57).to({state:[]},1).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},13).to({state:[{t:this.instance_2}]},2).wait(191));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24.5,-42.9,133,82.9);


(lib.water_drops_009 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// WET DROPS
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(171.9,1.4,0.486,0.486,0,0,0,4.8,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(159,15.9,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(130.1,22,0.486,0.486);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,17,18,23);


(lib.ToucanHead_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":70,"glowclean":71,"glowclean_loop":72,"final":73,"final_loop":74});

	// Toucan Head_001
	this.instance = new lib.ToucanHead_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(-5.3,12,1,1,0,0,0,-5.5,12.1);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},64).wait(274));

	// Layer 2
	this.instance_1 = new lib.ToucanHead_0030001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-17.7,-42.2,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(26,-26.7,0.4,0.5,0,0,180,50.5,5.2);

	this.instance_3 = new lib.ToucanHead_0030002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-17.7,-42.2,0.5,0.5);

	this.instance_4 = new lib.toucan_beakGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(36.8,-19.3,1.523,1.857,0,0,180,20.1,9.5);

	this.glow = new lib.beackglow3blue();
	this.glow.parent = this;
	this.glow.setTransform(33.9,-19.2,1.3,1.857,0,0,180,20.1,9.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_4}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2}]},7).to({state:[{t:this.instance_3},{t:this.instance_2}]},57).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.glow}]},1).to({state:[{t:this.instance_3}]},2).to({state:[]},3).to({state:[]},191).wait(77));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-17.7,-47,96,88.8);


(lib.ToucanHead_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":70,"glowclean":81,"glowclean_loop":82,"final":83,"final_loop":84});

	// Toucan Head_001
	this.instance = new lib.ToucanHead_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(-5.3,12,1,1,0,0,0,-5.5,12.1);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},64).wait(206));

	// Layer 2
	this.instance_1 = new lib.ToucanHead_0020001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-21,-39.9,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(36,-26.2,0.5,0.5,0,0,180,50.6,5.2);

	this.instance_3 = new lib.ToucanHead_0020002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-21,-39.9,0.5,0.5);

	this.instance_4 = new lib.toucan_beakGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(43.1,-20.3,1.5,1.5,0,0,180,20.2,9.6);

	this.glow = new lib.beackglow2blue();
	this.glow.parent = this;
	this.glow.setTransform(43.1,-20.3,1.5,1.5,0,0,180,20.2,9.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_4}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2}]},7).to({state:[{t:this.instance_3},{t:this.instance_2}]},57).to({state:[]},1).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.glow}]},10).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(191));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-21,-43.6,109.3,82.7);


(lib.Toucan = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{rest:0,rest_stop:114,wrongAnswer:116,"clean":140,clean_stop:154,wet:156,wet_stop:168,excited:170,excited_stop:196,animalSound:218});

	// timeline functions:
	this.frame_114 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_138 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_154 = function() {
		/* stop();
		*/
	}
	this.frame_168 = function() {
		/* stop();
		*/
	}
	this.frame_216 = function() {
		/* 
		
		
		gameObjects._game.done();
		
		stop();*/
	}
	this.frame_246 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(114).call(this.frame_114).wait(24).call(this.frame_138).wait(16).call(this.frame_154).wait(14).call(this.frame_168).wait(48).call(this.frame_216).wait(30).call(this.frame_246).wait(1));

	// Toucan Head_001
	this.beak_bubbles = new lib.ToucanHead_001_bubbles();
	this.beak_bubbles.parent = this;
	this.beak_bubbles.setTransform(505.6,135.1,0.36,0.36,0,0,180,-5.4,12.1);
	this.beak_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.beak_bubbles).to({_off:true},156).wait(91));

	// Toucan Wing
	this.back_bubbles = new lib.ToucanWing_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(506,142.7,0.36,0.36,0,0,180,33.4,0);
	this.back_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,3);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).to({_off:true},156).wait(91));

	// Toucan Tail
	this.tail_bubbles = new lib.ToucanTail_bubbles();
	this.tail_bubbles.parent = this;
	this.tail_bubbles.setTransform(532,145.9,0.36,0.36,0,-15,165,26.6,-25.4);
	this.tail_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.tail_bubbles).to({_off:true},156).wait(91));

	// Toucan Wingspan Left Leg
	this.instance = new lib.sparkle();
	this.instance.parent = this;
	this.instance.setTransform(496.8,144.7,0.15,0.15);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(204).to({_off:false},0).to({_off:true},14).wait(29));

	// Toucan Wingspan Right Leg
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(483,122.9,0.15,0.15);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(196).to({_off:false},0).to({_off:true},22).wait(29));

	// Toucan Wingspan Tail
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(540.7,125.9,0.15,0.15);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(212).to({_off:false},0).to({_off:true},6).wait(29));

	// Layer 3
	this.instance_3 = new lib.water_drops_009();
	this.instance_3.parent = this;
	this.instance_3.setTransform(528.3,141.9,0.361,0.361,0,0,180,92.5,49.4);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(156).to({_off:false},0).to({_off:true},14).wait(77));

	// Toucan Head
	this.toucan_head = new lib.ToucanHead_001();
	this.toucan_head.parent = this;
	this.toucan_head.setTransform(505.6,135.1,0.36,0.36,0,0,180,-5.4,12.1);
	this.toucan_head.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.toucan_head_1 = new lib.ToucanHead_002();
	this.toucan_head_1.parent = this;
	this.toucan_head_1.setTransform(505.6,136,0.359,0.359,0,-14.1,165.9,-5.2,12.1);
	this.toucan_head_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.toucan_head_2 = new lib.ToucanHead_003();
	this.toucan_head_2.parent = this;
	this.toucan_head_2.setTransform(506.7,136,0.359,0.359,0,-14,166,-5.2,12.1);
	this.toucan_head_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);
	this.toucan_head_2._off = true;

	this.toucan_head_3 = new lib.ToucanWingspanHead2();
	this.toucan_head_3.parent = this;
	this.toucan_head_3.setTransform(520.1,132.8,0.5,0.5,0,0,0,28.2,24.1);
	this.toucan_head_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,3);
	this.toucan_head_3._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.toucan_head}]}).to({state:[{t:this.toucan_head}]},38).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head_1,p:{x:505.6,y:136}}]},2).to({state:[{t:this.toucan_head_2}]},2).to({state:[{t:this.toucan_head_2}]},2).to({state:[{t:this.toucan_head_2}]},2).to({state:[{t:this.toucan_head_2}]},2).to({state:[{t:this.toucan_head_2}]},2).to({state:[{t:this.toucan_head_2}]},2).to({state:[{t:this.toucan_head_2}]},2).to({state:[{t:this.toucan_head_1,p:{x:505.6,y:136}}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},28).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},6).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},8).to({state:[{t:this.toucan_head}]},16).to({state:[{t:this.toucan_head}]},14).to({state:[{t:this.toucan_head_1,p:{x:509.1,y:135.4}}]},8).to({state:[{t:this.toucan_head_2}]},2).to({state:[{t:this.toucan_head_2}]},2).to({state:[{t:this.toucan_head_3}]},2).to({state:[{t:this.toucan_head_3}]},2).to({state:[{t:this.toucan_head_3}]},2).to({state:[{t:this.toucan_head_3}]},2).to({state:[{t:this.toucan_head_3}]},2).to({state:[{t:this.toucan_head}]},26).to({state:[{t:this.toucan_head}]},1).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},6).to({state:[{t:this.toucan_head}]},2).to({state:[{t:this.toucan_head}]},2).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.toucan_head).wait(40).to({regX:-5.5,skewX:1.3,skewY:181.3,x:506,y:134.5},0).wait(2).to({regX:-5.4,skewX:2,skewY:182,x:506.1,y:134.3},0).wait(2).to({regY:12,skewX:-3.8,skewY:176.2,x:505,y:134.9},0).wait(2).to({regX:-5.1,regY:12.2,skewX:-8.3,skewY:171.7,x:504.1,y:135.5},0).wait(2).to({regX:-5.5,regY:11.9,skewX:-11.5,skewY:168.5,x:503.6,y:135.7},0).wait(2).to({regX:-5.2,regY:12,scaleX:0.36,scaleY:0.36,skewX:-13.5,skewY:166.5,x:503.1,y:136},0).wait(2).to({regX:-5.3,regY:12.1,scaleX:0.36,scaleY:0.36,skewX:-14.2,skewY:165.8},0).to({_off:true},2).wait(18).to({_off:false},0).wait(2).to({regX:-4.7,regY:11.8,skewX:-6.3,skewY:173.7,x:503.8,y:135.5},0).wait(2).to({regX:-5.1,regY:12.1,skewX:-0.3,skewY:179.7,x:504.6,y:135.2},0).wait(2).to({regX:-5.4,regY:12.6,skewX:3.8,skewY:183.8,x:505.2,y:135.1},0).wait(2).to({regX:-5.7,regY:11.7,skewX:6.3,skewY:186.3,x:505.7,y:134.7},0).wait(2).to({regX:-5.5,regY:12.2,skewX:7.2,skewY:187.2,x:505.6,y:134.8},0).wait(2).to({regX:-5.2,regY:12.1,skewX:3.1,skewY:183.1,x:505.5,y:134.9},0).wait(2).to({regX:-5.5,regY:12.3,skewX:0.8,skewY:180.8,x:505.6,y:135},0).wait(2).to({regX:-5.4,regY:12.1,skewX:0,skewY:180,y:135.1},0).wait(30).to({regY:12,skewX:-3.8,skewY:176.2,x:505,y:134.9},0).wait(2).to({regX:-5.1,regY:12.2,skewX:-8.3,skewY:171.7,x:504.1,y:135.5},0).wait(2).to({regX:-5.5,regY:11.9,skewX:-11.5,skewY:168.5,x:503.6,y:135.7},0).wait(6).to({regX:-5.1,regY:12.2,skewX:-8.3,skewY:171.7,x:504.1,y:135.5},0).wait(2).to({regX:-5.4,regY:12,skewX:-3.8,skewY:176.2,x:505,y:134.9},0).wait(2).to({regY:12.1,skewX:0,skewY:180,x:505.6,y:135.1},0).wait(38).to({_off:true},8).wait(40).to({_off:false},0).wait(3).to({regY:12,skewX:-3.8,skewY:176.2,x:505,y:134.9},0).wait(2).to({regX:-5.1,regY:12.2,skewX:-8.3,skewY:171.7,x:504.1,y:135.5},0).wait(2).to({regX:-5.5,regY:11.9,skewX:-11.5,skewY:168.5,x:503.6,y:135.7},0).wait(6).to({regX:-5.1,regY:12.2,skewX:-8.3,skewY:171.7,x:504.1,y:135.5},0).wait(2).to({regX:-5.4,regY:12,skewX:-3.8,skewY:176.2,x:505,y:134.9},0).wait(2).to({regY:12.1,skewX:0,skewY:180,x:505.6,y:135.1},0).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.toucan_head_2).wait(56).to({_off:false},0).wait(12).to({_off:true},2).wait(110).to({_off:false,regX:-4.7,regY:12.7,scaleY:0.32,skewX:-6.5,skewY:173.5,x:512.6,y:136.4},0).wait(2).to({regX:-5.2,regY:12,scaleX:0.34,scaleY:0.34,rotation:-0.7,skewX:0,skewY:0,x:506.9,y:137.3},0).to({_off:true},2).wait(63));
	this.timeline.addTween(cjs.Tween.get(this.toucan_head_3).wait(184).to({_off:false},0).wait(2).to({x:521.1,y:130.5},0).wait(2).to({x:520.8,y:130.1},0).wait(2).to({x:520.4,y:129.7},0).wait(2).to({x:520.1,y:129.3},0).to({_off:true},26).wait(29));

	// Toucan Wing
	this.toucan_wing = new lib.ToucanWing();
	this.toucan_wing.parent = this;
	this.toucan_wing.setTransform(506,142.7,0.36,0.36,0,0,180,33.4,0);
	this.toucan_wing.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,3);

	this.toucan_wing_1 = new lib.ToucanWingspanTorso_1();
	this.toucan_wing_1.parent = this;
	this.toucan_wing_1.setTransform(512.3,145.9,0.523,0.587,0,-4.4,0,23.1,28);
	this.toucan_wing_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,3);
	this.toucan_wing_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.toucan_wing).wait(40).to({regY:-0.1,skewX:1.3,skewY:181.3,x:506.2,y:142.1},0).wait(2).to({skewX:2,skewY:182,x:506.3,y:141.9},0).wait(2).to({skewX:1,skewY:181,x:505.5,y:142.5},0).wait(2).to({regX:33.5,skewX:0.5,skewY:180.5,x:504.9,y:142.9},0).wait(2).to({skewX:0,skewY:180,x:504.4,y:143.2},0).wait(2).to({regX:33.4,x:504.2,y:143.4},0).wait(2).to({skewX:-0.2,skewY:179.8,x:504.1},0).wait(2).to({regX:33.5,regY:-0.2,skewX:-6.5,skewY:173.5,x:504.9,y:143.9},0).wait(2).to({regX:33.4,regY:-0.1,skewX:-10.3,skewY:169.7,x:505.5,y:144.2},0).wait(2).to({regY:0.1,skewX:-11.8,skewY:168.2,x:505.6,y:144.3},0).wait(2).to({regX:33.3,regY:0,skewX:-6,skewY:174,x:504.9,y:143.9},0).wait(2).to({regX:33.4,regY:-0.1,skewX:-0.2,skewY:179.8,x:504.1,y:143.4},0).wait(2).to({skewX:-8.8,skewY:171.2,x:505.2,y:144.2},0).wait(2).to({regY:0.1,skewX:-11.8,skewY:168.2,x:505.6,y:144.3},0).wait(2).to({regX:33.3,regY:0,skewX:-6,skewY:174,x:504.9,y:143.9},0).wait(2).to({regX:33.4,regY:-0.1,skewX:-0.2,skewY:179.8,x:504.1,y:143.4},0).wait(2).to({skewX:-0.2},0).wait(2).to({regY:0.1,skewX:0,skewY:180,x:504.8,y:143.1},0).wait(2).to({x:505.3,y:142.8},0).wait(2).to({regY:0,x:505.7,y:142.6},0).wait(2).to({x:505.9,y:142.4},0).wait(2).to({x:506},0).wait(2).to({y:142.5},0).wait(2).to({y:142.6},0).wait(2).to({y:142.7},0).wait(30).to({regY:-0.1,skewX:1,skewY:181,x:505.5,y:142.5},0).wait(2).to({regX:33.5,skewX:0.5,skewY:180.5,x:504.9,y:142.9},0).wait(2).to({skewX:0,skewY:180,x:504.4,y:143.2},0).wait(6).to({skewX:0.5,skewY:180.5,x:504.9,y:142.9},0).wait(2).to({regX:33.4,skewX:1,skewY:181,x:505.5,y:142.5},0).wait(2).to({regY:0,skewX:0,skewY:180,x:506,y:142.7},0).wait(46).to({regX:33.3,scaleX:0.28,x:510.4,y:142.3},0).wait(2).to({regX:33.2,scaleX:0.21,x:514.8,y:141.9},0).wait(2).to({regX:33.4,scaleX:0.14,x:519.2,y:141.6},0).to({_off:true},2).wait(34).to({_off:false,scaleX:0.36,x:506,y:142.7},0).wait(3).to({regY:-0.1,skewX:1,skewY:181,x:505.5,y:142.5},0).wait(2).to({regX:33.5,skewX:0.5,skewY:180.5,x:504.9,y:142.9},0).wait(2).to({skewX:0,skewY:180,x:504.4,y:143.2},0).wait(6).to({skewX:0.5,skewY:180.5,x:504.9,y:142.9},0).wait(2).to({regX:33.4,skewX:1,skewY:181,x:505.5,y:142.5},0).wait(2).to({regY:0,skewX:0,skewY:180,x:506,y:142.7},0).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.toucan_wing_1).wait(184).to({_off:false},0).wait(2).to({scaleY:0.59,skewX:0,skewY:-2,x:513},0).wait(2).to({regY:28.1,skewY:-1.3,y:145.7},0).wait(2).to({skewY:-0.5,y:145.5},0).wait(2).to({regY:28,skewY:0,y:145.3},0).to({_off:true},26).wait(29));

	// Toucan Torso
	this.instance_4 = new lib.ToucanTorso_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(516.9,146.9,0.36,0.36,0,0,180,0,14.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_5 = new lib.ToucanWingspanWing_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(506.8,140.2,0.5,0.5,0,13.8,-166.2,7.9,39.8);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,3);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(40).to({skewX:1.3,skewY:181.3,x:517,y:146.6},0).wait(2).to({regX:-0.1,skewX:2,skewY:182,x:517.1,y:146.5},0).wait(2).to({regX:-0.2,skewX:-0.5,skewY:179.5,x:516.4,y:146.6},0).wait(2).to({regX:0.1,skewX:-2.3,skewY:177.7,x:515.9,y:146.7},0).wait(2).to({regX:0,regY:14.4,skewX:-3.8,skewY:176.2,x:515.6,y:146.8},0).wait(2).to({regY:14.2,skewX:-4.5,skewY:175.5,x:515.4},0).wait(2).to({regX:-0.1,skewX:-4.9,skewY:175.1},0).wait(2).to({skewX:-4.8,skewY:175.2},0).wait(18).to({skewX:-4.9,skewY:175.1},0).wait(2).to({skewX:-3,skewY:177,x:516,y:146.7},0).wait(2).to({regY:14.3,skewX:-1.8,skewY:178.2,x:516.4},0).wait(2).to({regX:0.1,skewX:-0.8,skewY:179.2,x:516.5},0).wait(2).to({regX:-0.1,regY:14.1,skewX:-0.1,skewY:179.9,x:516.8,y:146.6},0).wait(2).to({regX:0,regY:14.2,skewX:0,skewY:180,x:516.9},0).wait(2).to({y:146.8},0).wait(2).to({y:146.9},0).wait(32).to({regX:-0.2,skewX:-0.5,skewY:179.5,x:516.4,y:146.6},0).wait(2).to({regX:0.1,skewX:-2.3,skewY:177.7,x:515.9,y:146.7},0).wait(2).to({regX:0,regY:14.4,skewX:-3.8,skewY:176.2,x:515.6,y:146.8},0).wait(6).to({regX:0.1,regY:14.2,skewX:-2.3,skewY:177.7,x:515.9,y:146.7},0).wait(2).to({regX:-0.2,skewX:-0.5,skewY:179.5,x:516.4,y:146.6},0).wait(2).to({regX:0,skewX:0,skewY:180,x:516.9,y:146.9},0).wait(46).to({scaleX:0.32,scaleY:0.36,skewX:4.5,x:515.7,y:147.1},0).wait(2).to({regX:-0.1,scaleX:0.28,scaleY:0.37,skewX:9.3,x:514.6,y:147.3},0).wait(2).to({scaleX:0.24,scaleY:0.37,skewX:13.9,x:513.4,y:147.4},0).to({_off:true},2).wait(34).to({_off:false,regX:0,scaleX:0.36,scaleY:0.36,skewX:0,x:516.9,y:146.9},0).wait(3).to({regX:-0.2,skewX:-0.5,skewY:179.5,x:516.4,y:146.6},0).wait(2).to({regX:0.1,skewX:-2.3,skewY:177.7,x:515.9,y:146.7},0).wait(2).to({regX:0,regY:14.4,skewX:-3.8,skewY:176.2,x:515.6,y:146.8},0).wait(6).to({regX:0.1,regY:14.2,skewX:-2.3,skewY:177.7,x:515.9,y:146.7},0).wait(2).to({regX:-0.2,skewX:-0.5,skewY:179.5,x:516.4,y:146.6},0).wait(2).to({regX:0,skewX:0,skewY:180,x:516.9,y:146.9},0).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(186).to({_off:false},0).wait(2).to({regY:39.6,scaleX:0.5,scaleY:0.5,skewX:12.3,skewY:-167.7,y:140.1},0).wait(2).to({regY:39.9,skewX:10.8,skewY:-169.2,y:140.3},0).wait(2).to({regX:7.8,scaleX:0.5,scaleY:0.5,skewX:9.3,skewY:-170.7,x:506.9,y:140.2},0).to({_off:true},26).wait(29));

	// Toucan Leg
	this.instance_6 = new lib.ToucanLeg_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(515.4,157.9,0.36,0.36,0,0,180,1.2,10.2);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_7 = new lib.Tween1fdfsvtoucanwing_1("synched",0);
	this.instance_7.parent = this;
	this.instance_7.setTransform(518.1,136.2);

	this.instance_8 = new lib.ToucanWingspanWing_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(522.6,139.1,0.5,0.5,-20.2,0,0,11.2,38.8);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,3);
	this.instance_8._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_6}]},38).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},28).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},6).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},8).to({state:[{t:this.instance_6}]},16).to({state:[{t:this.instance_6}]},14).to({state:[{t:this.instance_6}]},6).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_6}]},26).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},6).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(40).to({scaleY:0.38},0).wait(2).to({regY:10.3,scaleY:0.39,y:157.8},0).wait(2).to({scaleY:0.38,skewX:-3.8,x:515.3,y:157.9},0).wait(2).to({regY:10.4,scaleY:0.37,skewX:-6.8,x:515.2},0).wait(2).to({regY:10.5,scaleY:0.37,skewX:-8.8,x:515.1,y:158},0).wait(2).to({regX:1.3,regY:10.4,scaleY:0.37,skewX:-10.1,x:515},0).wait(2).to({regY:10.2,scaleY:0.37,skewX:-10.7,x:515.1,y:157.9},0).wait(2).to({regX:1.2,regY:10.3,skewX:-10.5,y:158},0).wait(18).to({regX:1.3,regY:10.2,skewX:-10.7,y:157.9},0).wait(2).to({regX:1.2,scaleY:0.36,skewX:-6.8,x:515.2,y:158},0).wait(2).to({scaleY:0.36,skewX:-3.8,x:515.3},0).wait(2).to({regX:1.3,scaleY:0.36,skewX:-1.6,y:157.9},0).wait(2).to({scaleY:0.36,skewX:-0.3,x:515.4},0).wait(2).to({regX:1.2,skewX:0},0).wait(36).to({regY:10.3,scaleY:0.38,skewX:-3.8,x:515.3},0).wait(2).to({regY:10.4,scaleY:0.37,skewX:-6.8,x:515.2},0).wait(2).to({regY:10.5,scaleY:0.37,skewX:-8.8,x:515.1,y:158},0).wait(6).to({regY:10.4,scaleY:0.37,skewX:-6.8,x:515.2,y:157.9},0).wait(2).to({regY:10.3,scaleY:0.38,skewX:-3.8,x:515.3},0).wait(2).to({regY:10.2,scaleY:0.36,skewX:0,x:515.4},0).wait(50).to({_off:true},2).wait(34).to({_off:false},0).wait(3).to({regY:10.3,scaleY:0.38,skewX:-3.8,x:515.3},0).wait(2).to({regY:10.4,scaleY:0.37,skewX:-6.8,x:515.2},0).wait(2).to({regY:10.5,scaleY:0.37,skewX:-8.8,x:515.1,y:158},0).wait(6).to({regY:10.4,scaleY:0.37,skewX:-6.8,x:515.2,y:157.9},0).wait(2).to({regY:10.3,scaleY:0.38,skewX:-3.8,x:515.3},0).wait(2).to({regY:10.2,scaleY:0.36,skewX:0,x:515.4},0).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(186).to({_off:false},0).wait(2).to({regX:11.1,regY:38.7,rotation:-18.3},0).wait(2).to({regY:38.8,rotation:-16.6},0).wait(2).to({regX:11.2,rotation:-15},0).to({_off:true},26).wait(29));

	// Toucan Lower Leg
	this.instance_9 = new lib.ToucanLowerLeg_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(511.3,158,0.36,0.36,0,0,180,0.8,12.5);

	this.instance_10 = new lib.ToucanWingspanLeftLeg_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(519.6,150.5,0.523,0.497,0,5.2,0,5.7,7.1);
	this.instance_10._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(40).to({scaleY:0.38,y:157.9},0).wait(2).to({regY:12.6,scaleY:0.39},0).wait(2).to({regX:0.9,scaleY:0.38,skewX:-3.8,x:511.2},0).wait(2).to({regX:0.8,scaleY:0.37,skewX:-6.8,x:511.1},0).wait(2).to({regY:12.7,scaleY:0.37,skewX:-8.8,x:511,y:158},0).wait(2).to({regY:12.6,scaleY:0.37,skewX:-10.1},0).wait(2).to({regY:12.5,scaleY:0.37,skewX:-10.7},0).wait(2).to({skewX:-10.5},0).wait(18).to({skewX:-10.7},0).wait(2).to({scaleY:0.36,skewX:-6.8,x:511.2},0).wait(2).to({scaleY:0.36,skewX:-3.8},0).wait(2).to({scaleY:0.36,skewX:-1.6,y:157.9},0).wait(2).to({regX:0.9,scaleY:0.36,skewX:-0.3,x:511.3,y:158},0).wait(2).to({regX:0.8,skewX:0},0).wait(36).to({regX:0.9,regY:12.6,scaleY:0.38,skewX:-3.8,x:511.2,y:157.9},0).wait(2).to({regX:0.8,scaleY:0.37,skewX:-6.8,x:511.1},0).wait(2).to({regY:12.7,scaleY:0.37,skewX:-8.8,x:511,y:158},0).wait(6).to({regY:12.6,scaleY:0.37,skewX:-6.8,x:511.1,y:157.9},0).wait(2).to({regX:0.9,scaleY:0.38,skewX:-3.8,x:511.2},0).wait(2).to({regX:0.8,regY:12.5,scaleY:0.36,skewX:0,x:511.3,y:158},0).wait(50).to({_off:true},2).wait(34).to({_off:false},0).wait(3).to({regX:0.9,regY:12.6,scaleY:0.38,skewX:-3.8,x:511.2,y:157.9},0).wait(2).to({regX:0.8,scaleY:0.37,skewX:-6.8,x:511.1},0).wait(2).to({regY:12.7,scaleY:0.37,skewX:-8.8,x:511,y:158},0).wait(6).to({regY:12.6,scaleY:0.37,skewX:-6.8,x:511.1,y:157.9},0).wait(2).to({regX:0.9,scaleY:0.38,skewX:-3.8,x:511.2},0).wait(2).to({regX:0.8,regY:12.5,scaleY:0.36,skewX:0,x:511.3,y:158},0).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(184).to({_off:false},0).wait(2).to({regX:5.8,regY:7,scaleY:0.52,skewX:0,x:518.8,y:150},0).wait(6).to({_off:true},26).wait(29));

	// Toucan Upper Leg
	this.instance_11 = new lib.ToucanUpperLeg_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(517.1,141.8,0.36,0.36,0,0,180);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_12 = new lib.ToucanWingspanRightLeg_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(514.9,150.8,0.523,0.497,0,5.2,0,18.2,7.1);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,0);
	this.instance_12._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(182).to({_off:true},2).wait(34).to({_off:false},0).wait(29));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(184).to({_off:false},0).wait(2).to({regX:5.9,scaleY:0.52,skewX:0,x:507.7,y:150.3},0).wait(6).to({_off:true},26).wait(29));

	// Toucan Leg
	this.instance_13 = new lib.ToucanLeg_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(513.9,144.3,0.36,0.36,0,0,180);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_14 = new lib.ToucanWingspanTail_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(513.2,152.8,0.542,0.5,0,0,0,15.5,7);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,3);
	this.instance_14._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(182).to({_off:true},2).wait(34).to({_off:false},0).wait(29));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(184).to({_off:false},0).wait(2).to({scaleX:0.5,y:152.5},0).wait(6).to({_off:true},26).wait(29));

	// Toucan Tail
	this.toucan_tail = new lib.ToucanTail();
	this.toucan_tail.parent = this;
	this.toucan_tail.setTransform(532,145.9,0.36,0.36,0,-15,165,26.6,-25.4);
	this.toucan_tail.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.toucan_tail).wait(40).to({regX:26.9,regY:-25.5,scaleX:0.36,scaleY:0.36,skewX:-13.5,skewY:166.5},0).wait(2).to({regX:26.6,regY:-25.4,scaleX:0.36,scaleY:0.36,skewX:-13,skewY:167,x:532.2,y:146},0).wait(2).to({regX:26.4,regY:-25.8,scaleX:0.36,scaleY:0.36,skewX:-28.1,skewY:151.9,x:531.5,y:144.7},0).wait(2).to({regX:26.2,regY:-25.6,skewX:-39.6,skewY:140.4,x:531,y:143.9},0).wait(2).to({regX:26.6,regY:-25.4,skewX:-48.1,skewY:131.9,x:530.6,y:143.3},0).wait(2).to({regX:26.7,regY:-25.6,skewX:-53.1,skewY:126.9,x:530.3,y:143},0).wait(2).to({scaleX:0.36,scaleY:0.36,skewX:-54.7,skewY:125.3,y:142.9},0).wait(2).to({regX:26.6,regY:-25.7,scaleX:0.36,scaleY:0.36,y:142.8},0).wait(18).to({regX:26.7,regY:-25.6,scaleX:0.36,scaleY:0.36,y:142.9},0).wait(2).to({regY:-25.8,scaleX:0.36,scaleY:0.36,skewX:-40.4,skewY:139.6,x:530.9,y:143.8},0).wait(2).to({regX:26.5,regY:-25.6,skewX:-29.3,skewY:150.7,x:531.4,y:144.6},0).wait(2).to({regX:26.6,skewX:-21.3,skewY:158.7,x:531.8,y:145.1},0).wait(2).to({regX:26.7,regY:-25.5,skewX:-16.5,skewY:163.5,x:531.9,y:145.5},0).wait(2).to({regX:26.6,regY:-25.4,scaleX:0.36,scaleY:0.36,skewX:-15,skewY:165,x:532,y:145.6},0).wait(2).to({regX:26.8,regY:-25.7,scaleX:0.36,scaleY:0.36,skewX:-14.8,skewY:165.2,x:531.9},0).wait(2).to({regX:26.7,regY:-25.5,y:145.8},0).wait(2).to({regX:26.6,regY:-25.4,scaleX:0.36,scaleY:0.36,skewX:-15,skewY:165,x:532,y:145.9},0).wait(30).to({regX:26.4,regY:-25.8,scaleX:0.36,scaleY:0.36,skewX:-28.1,skewY:151.9,x:531.5,y:144.7},0).wait(2).to({regX:26.2,regY:-25.6,skewX:-39.6,skewY:140.4,x:531,y:143.9},0).wait(2).to({regX:26.6,regY:-25.4,skewX:-48.1,skewY:131.9,x:530.6,y:143.3},0).wait(6).to({regX:26.2,regY:-25.6,skewX:-39.6,skewY:140.4,x:531,y:143.9},0).wait(2).to({regX:26.4,regY:-25.8,skewX:-28.1,skewY:151.9,x:531.5,y:144.7},0).wait(2).to({regX:26.6,regY:-25.4,scaleX:0.36,scaleY:0.36,skewX:-15,skewY:165,x:532,y:145.9},0).wait(46).to({regX:26.3,regY:-25,scaleX:0.38,scaleY:0.38,skewX:2.5,skewY:173.2,x:527.7,y:143.1},0).wait(2).to({regX:26.5,regY:-25.3,scaleX:0.4,scaleY:0.41,skewX:20.1,skewY:181.3,x:523.1,y:140},0).wait(2).to({regX:27.2,regY:-26,scaleX:0.41,scaleY:0.43,skewX:37.8,skewY:189.6,x:518.7,y:137},0).to({_off:true},2).wait(34).to({_off:false,regX:26.6,regY:-25.4,scaleX:0.36,scaleY:0.36,skewX:-15,skewY:165,x:532,y:145.9},0).wait(3).to({regX:26.4,regY:-25.8,scaleX:0.36,scaleY:0.36,skewX:-28.1,skewY:151.9,x:531.5,y:144.7},0).wait(2).to({regX:26.2,regY:-25.6,skewX:-39.6,skewY:140.4,x:531,y:143.9},0).wait(2).to({regX:26.6,regY:-25.4,skewX:-48.1,skewY:131.9,x:530.6,y:143.3},0).wait(6).to({regX:26.2,regY:-25.6,skewX:-39.6,skewY:140.4,x:531,y:143.9},0).wait(2).to({regX:26.4,regY:-25.8,skewX:-28.1,skewY:151.9,x:531.5,y:144.7},0).wait(2).to({regX:26.6,regY:-25.4,scaleX:0.36,scaleY:0.36,skewX:-15,skewY:165,x:532,y:145.9},0).wait(12));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(460.6,112,105.7,65.2);


(lib.toucan = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// beakGlow
	this.beakGlow = new lib.toucan_beakGlow();
	this.beakGlow.parent = this;
	this.beakGlow.setTransform(178.9,156,1,1,0,0,0,20.3,9.6);
	this.beakGlow.alpha = 0;
	this.beakGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.beakGlow.cache(-3,-3,48,26);

	this.timeline.addTween(cjs.Tween.get(this.beakGlow).wait(1));

	// backGlow
	this.backGlow = new lib.toucan_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(232.5,185.4,1,1,0,0,0,28.9,11.1);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.backGlow.cache(12,-10,49,34);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// tailGlow
	this.tailGlow = new lib.toucan_tailGlow();
	this.tailGlow.parent = this;
	this.tailGlow.setTransform(273.3,202.8,1,1,0,0,0,20.8,14.4);
	this.tailGlow.alpha = 0;
	this.tailGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.tailGlow.cache(-1,-2,46,34);

	this.timeline.addTween(cjs.Tween.get(this.tailGlow).wait(1));

	// tail
	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(274.8,203.3,0.485,1.082,-63);

	this.timeline.addTween(cjs.Tween.get(this.tail).wait(1));

	// foot
	this.foot = new lib.invisiblebox();
	this.foot.parent = this;
	this.foot.setTransform(224.8,208.1,0.302,0.681,-88.2);

	this.timeline.addTween(cjs.Tween.get(this.foot).wait(1));

	// back
	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(240.6,179.6,0.516,0.787,-63);

	this.timeline.addTween(cjs.Tween.get(this.back).wait(1));

	// neck
	this.neck = new lib.invisiblebox();
	this.neck.parent = this;
	this.neck.setTransform(208.6,170.5,0.41,0.694,55.7);

	this.timeline.addTween(cjs.Tween.get(this.neck).wait(1));

	// beak
	this.beak = new lib.invisiblebox();
	this.beak.parent = this;
	this.beak.setTransform(179.5,154.5,1.158,0.539,-8.8);

	this.timeline.addTween(cjs.Tween.get(this.beak).wait(1));

	// main
	this.main = new lib.Toucan();
	this.main.parent = this;
	this.main.setTransform(-584.7,43,1.643,1.643,0,0,0,20.6,55.4);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.toucan, new cjs.Rectangle(140.7,138.5,165.8,100.5), null);


// stage content:
(lib.MWtoucan = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWtoucan_atlas_.png?1528309736438", id:"MWtoucan_atlas_"}
	],
	preloads: []
};




})(lib_Toucan = lib_Toucan||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Toucan, images, createjs, ss, AdobeAn;